import React, { useState, useCallback } from "react";

import DrawerMenu from "components/DrawerMenu";

import { useAuth } from "lib/firebase-provider/Auth";

import { Box } from "@material-ui/core";

import { useHistory } from "react-router-dom";

import { useLocalStorage } from "@rehooks/local-storage";

import AppHeader from "components/AppHeader";

import HelpDialog from "pages/HelpDialog";

import DownloadDialog from "components/DownloadDialog";

import { useDataDates } from "lib/config";

export default function ContentLayout(props) {
  const { startDate, endDate } = useDataDates();

  const { topBar, content } = props;

  const { getCurrentUser, signOut } = useAuth();

  const [showDrawer, setShowDrawer] = useState(false);
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);

  const handleDownloadDialogClose = () => {
    setDownloadDialogOpen(false);
  }

  let [helpDialogOpen, setHelpDialogOpen] = useState(null);

  const history = useHistory();

  const handleSignout = useCallback(() => {
    signOut();
    history.push("/");
  }, [signOut, history]);

  const currentUser = getCurrentUser();

  const [showHelpDialogAtStartup, setShowHelpDialogAtStartup] = useLocalStorage(
    "do-not-show-welcome-dialog",
    true
  );

  if (helpDialogOpen === null) {
    helpDialogOpen = !showHelpDialogAtStartup;
  }

  const handleHelpDialogClose = useCallback(() => {
    setHelpDialogOpen(false);
  }, [setHelpDialogOpen]);

  function handleDrawerOpen() {
    setShowDrawer(true);
  }

  const handleHelpDialogOpen = useCallback(() => {
    setHelpDialogOpen(true);
  }, [setHelpDialogOpen]);

  function handleDrawerClose() {
    setShowDrawer(false);
  }

  const handleDownloadOpen = useCallback(() => {
    setDownloadDialogOpen(true);
  }, [setDownloadDialogOpen]);

  return (
    <Box style={{ height: "100%" }} display="flex" flexDirection="column">
      <DrawerMenu
        onDownloadDialogOpen={handleDownloadOpen}
        onHelpOpen={handleHelpDialogOpen}
        onDrawerClose={handleDrawerClose}
        open={showDrawer}
        currentUser={currentUser}
        onSignOut={handleSignout}
      />
      <DownloadDialog
        open={downloadDialogOpen}
        onClose={handleDownloadDialogClose}
        minDate={startDate}
        maxDate={endDate}
      />
      <HelpDialog
        open={helpDialogOpen}
        onClose={handleHelpDialogClose}
        showHelpDialogAtStartup={showHelpDialogAtStartup}
        onShowHelpDialogAtStartupChange={setShowHelpDialogAtStartup}
      />

      {/* TopBar */}
      <Box flexBasis={0} order={1} width="100%">
        <AppHeader onOpenDrawer={handleDrawerOpen}>{topBar(props)}</AppHeader>
      </Box>

      {/* Main Content */}
      <Box order={2} flexBasis={0} flexGrow={1} position="relative">
        {content(props)}
      </Box>
    </Box>
  );
}
